module.exports = __webpack_public_path__ + "static/media/usa-flag.513ec305.png";